'use strict'

export const Main = {
  extend: ['Page'],
  Controller: {}
}
